import { cva } from '@/styled-system/css';

export const accordionHeaderRecipe = cva({
  base: {
    'alignItems': 'center',
    'borderTopLeftRadius': 'obj.default',
    'borderTopRightRadius': 'obj.default',
    'cursor': 'pointer',
    'display': 'flex',
    'gap': 'default',
    'padding': 'default',
    'position': 'relative',
    'zIndex': 1,

    '& .c11n_heading': {
      color: { base: 'text.neutral' },
    },

    '& .c11n_icon': {
      color: { base: 'icon.neutral' },
      height: 'icon.sm',
      width: 'icon.sm',
    },
  },
  variants: {
    disabled: {
      true: {
        cursor: 'default',
        opacity: 'disabled',
      },
      false: {
        cursor: 'pointer',
        _hover: {
          '& .c11n_heading': {
            textDecoration: 'underline',
          },
        },
        _active: {
          '& .c11n_heading': {
            textDecoration: 'underline',
          },
        },
      },
    },
    expanded: {
      true: {},
      false: {
        borderBottomLeftRadius: 'obj.default',
        borderBottomRightRadius: 'obj.default',
      },
    },
  },
});
